import React, { forwardRef } from "react";
import { Skeleton, Box, Stack } from "@mui/material";
import { DashboardCard } from "@/Pages/Dashboard/dashboardConfig";
import tokens from "@/theme/tokens";

const NUMBER_OF_TILES = 10;

export const CarouselSkeletonWithoutHeading = () => (
  <Stack
    direction="row"
    sx={{
      gap: tokens.space.px24,
      mt: 3,
      width: "max-content"
    }}>
    {Array(NUMBER_OF_TILES)
      .fill("")
      .map((_, index) => (
        <Skeleton
          // eslint-disable-next-line react/no-array-index-key
          key={`carousel-skeleton-${index}`}
          animation="wave"
          variant="rectangular"
          height={DashboardCard.height}
          width={DashboardCard.width}
        />
      ))}
  </Stack>
);

const CarouselSkeleton = forwardRef((props, ref) => {
  return (
    <Box ref={ref} sx={{ mb: 4, overflow: "hidden", mr: { xs: -2, sm: 0 } }}>
      <Skeleton
        animation="wave"
        variant="rectangular"
        height={18}
        width={200}
      />
      <CarouselSkeletonWithoutHeading />
    </Box>
  );
});

export default CarouselSkeleton;
